import React, { useState } from "react";
import "../../../styles/createAccount.css";
import { AuthServices } from "../services/AuthServices";
import { useNavigate } from "react-router-dom";
import useUpdateOnboardingStatus from "../../../utils/hooks/useUpdateOnboardingStatus";

const StoreHours = ({ setStep }) => {
  const updateOnboardingStatus = useUpdateOnboardingStatus();
  const navigate = useNavigate();
  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const [hours, setHours] = useState(
    daysOfWeek.map((day) => ({
      day,
      enabled: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
      ].includes(day),
      start: "07:00",
      end: "17:00",
    }))
  );

  const toggleDay = (index) => {
    setHours((prev) =>
      prev.map((d, i) => (i === index ? { ...d, enabled: !d.enabled } : d))
    );
  };

  const updateTime = (index, type, value) => {
    setHours((prev) =>
      prev.map((d, i) => (i === index ? { ...d, [type]: value } : d))
    );
  };

  const handleSubmit = async () => {
    const response = await AuthServices.updateStoreOperations(hours);
    if (response.data?.status === 401) {
      navigate("/");
      return;
    }

    const updateStatus = await updateOnboardingStatus("storeOperations");
    if (!updateStatus) {
      console.log(
        "There was a problem updating your onboarding status, please try again"
      );
      return;
    }
    setStep(4);
  };

  return (
    <div className="store-hours-container">
      <div className="header">
        <div className="icon">🛒</div>
        <h1>Set your store hours</h1>
        <p>Provide essential information about your store.</p>
      </div>

      <ul className="hours-list">
        {hours.map((day, index) => (
          <li key={day.day} className="hours-item">
            <label className="switch">
              <input
                type="checkbox"
                checked={day.enabled}
                onChange={() => toggleDay(index)}
              />
              <span className="slider round"></span>
            </label>
            <span className={`day-label ${!day.enabled ? "disabled" : ""}`}>
              {day.day}
            </span>
            <input
              type="time"
              value={day.start}
              disabled={!day.enabled}
              onChange={(e) => updateTime(index, "start", e.target.value)}
            />
            <span>—</span>
            <input
              type="time"
              value={day.end}
              disabled={!day.enabled}
              onChange={(e) => updateTime(index, "end", e.target.value)}
            />
          </li>
        ))}
      </ul>

      <button className="continue-btn" onClick={handleSubmit}>
        Continue
      </button>
    </div>
  );
};

export default StoreHours;
